import { render, staticRenderFns } from "./CommandsPanel.vue?vue&type=template&id=d64c0c0c&scoped=true&"
import script from "./CommandsPanel.vue?vue&type=script&lang=js&"
export * from "./CommandsPanel.vue?vue&type=script&lang=js&"
import style0 from "./CommandsPanel.vue?vue&type=style&index=0&id=d64c0c0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64c0c0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d64c0c0c')) {
      api.createRecord('d64c0c0c', component.options)
    } else {
      api.reload('d64c0c0c', component.options)
    }
    module.hot.accept("./CommandsPanel.vue?vue&type=template&id=d64c0c0c&scoped=true&", function () {
      api.rerender('d64c0c0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Map/components/CommandsPanel.vue"
export default component.exports